import React, { Component } from 'react'

export default class StartNode extends Component {
    constructor(props) {
      super(props)
    
      this.state = {
         
      }
    }
    
  render() {
    return (
        <div id="blankpanel" style={{height:'100%',display:'none'}}>
         空白
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiFlow/Workflow/Component/StartNode.js